import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as common from '../../../../../common'

export const DOC = gql`
  ${common.gql.dms.data.fragments.variable.DOC}
  fragment FragmentMosaicPageForDev on MosaicPageForDev {
    id
    alias
    name
    description
    query
    content
    variables {
      ...FragmentVariable
    }
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentMosaicPageForDevFragment,
  ents.core.mosaic.Page
>({
  alias: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
  content: {
    usingFullInput: graphql.transformers.OUT.custom(
      // TODO Currently content is received as AWSJSON and we don't have a way
      // to check if it's a valid content, so we need to cast it. Once the
      // MosaicPageForDev graphQL type is changed and we receive content typed
      // as MosaicPageContent we should use proper transformer for it.
      ({ content }) =>
        JSON.parse(content as string) as ents.core.mosaic.Page.Content,
    ),
  },
  description: transformers.PASS_THROUGH,
  id: transformers.PASS_THROUGH,
  name: graphql.transformers.OUT.default(transformers.PASS_THROUGH, ''),
  query: graphql.transformers.OUT.validate(
    graphql.transformers.OUT.json({ onNullish: 'preserve' }),
    ents.core.mosaic.Widget.Query.assertIsQuery,
    { warnOnly: true },
  ),
  variables: {
    usingFullInput: graphql.transformers.OUT.default(
      graphql.transformers.OUT.select(
        'variables',
        graphql.transformers.OUT.list(
          common.gql.dms.data.fragments.variable.TRANSFORMER,
          { onNullish: 'remove' },
        ),
      ),
      [],
    ),
  },
})
